import { useEffect, useState } from 'react';
import { useSetAtom } from 'jotai';
import { whiteLabelThemeConfigState } from '../store/whitelabel-theme-settings';
import * as WL from '../constants/white-label-config';
import { getWhitelabelUIConfig } from '../api/whitelabel';
import { isEmbedded } from '../utilities';

// Resolves the white-label theme from the current subdomain BEFORE authentication
// so the login screen is branded. The Cyberint subdomain skips the fetch and uses
// the default config; white-labeled subdomains fetch their UI config, falling back
// to the default on error. Returns a `loading` flag so callers can gate rendering
// of anything that consumes `whiteLabelConfig` (e.g. the login page) until the
// theme is set.
export const useWhiteLabelInit = () => {
  const setTheme = useSetAtom(whiteLabelThemeConfigState);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      const subdomain = WL.getSubdomainForEnv();
      const appEl = document.getElementById('app');

      if (subdomain === WL.MAIN_BRAND_NAME || isEmbedded) {
        // Our own tenant (or embedded mode) — no need to fetch a white-label
        // configuration; use the default Cyberint theme.
        setTheme(WL.whiteLabelCompanyConfig());
        appEl?.style.setProperty('--login-bg-teal', '#003d40');
        appEl?.style.setProperty('--login-bg-dark', '#001c20');
        setLoading(false);
        return;
      }

      try {
        const response = await getWhitelabelUIConfig(subdomain);
        const themeData = response?.data;

        setTheme({
          ...themeData,
          primary_main_color: themeData.colors.primary.main,
          secondary_main_color: themeData.colors.secondary.main,
          login_divider: themeData.colors.login.loginDivider
        });
        appEl?.style.setProperty('--login-bg-teal', themeData.colors.primary.main);
        appEl?.style.setProperty('--login-bg-dark', '#0a0a0a');
      } catch (e) {
        setTheme(WL.whiteLabelCompanyConfig());
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [setTheme]);

  return loading;
};
